import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import {
    type LoadingColorConstantType,
    type LoadingSizeConstantType,
    type LoadingDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../types";
import {
    webStyle
} from "../../utils";

export const LOADING_BRAND_PATH = "M11.885 7.303 19 3.194l7.115 4.109v8.215l7.095 4.09v8.215l-7.115 4.108-7.076-4.108-7.114 4.108-7.115-4.108v-8.216l7.095-4.089V7.303Z";

export const LOADING_BRAND_VIEWBOX = "0 0 38 38";

export const LOADING_BRAND_STROKE_WIDTH = 3;

export const getLoadingSize = ({
    iconSizes,
    size
}: LoadingSizeConstantType): number => {
    if(typeof size === "number") {
        return size;
    }

    return iconSizes[size];
};

export const getLoadingColor = ({
    customColor,
    colors,
    color
}: LoadingColorConstantType): string => {
    if(!customColor) {
        return colors.content.icon[color];
    }

    const projectColor = colors.project[customColor as keyof NCoreUIKit.ProjectColorPalette];

    return projectColor ? projectColor : customColor;
};

const stylesheet = StyleSheet.create({
    webSpin: webStyle({
        animationIterationCount: "infinite",
        animationKeyframes: {
            to: {
                transform: "rotate(360deg)"
            },
            from: {
                transform: "rotate(0deg)"
            }
        },
        animationTimingFunction: "linear"
    }),
    container: {
        justifyContent: "center",
        alignItems: "center"
    }
});

export const useStyles = ({
    spinDuration,
    size
}: LoadingDynamicStyleType) => {
    const styles = {
        webSpin: webStyle({
            animationDuration: `${spinDuration}ms`
        }) as Mutable<ViewStyle>,
        container: {
            height: size,
            width: size
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
